import * as React from "react"

import GenericIconProps from './_icon.type';

function HamburgerMenuIcon({className = 'fill-neutrals-900'}: GenericIconProps) {
  return (
    <svg
      className={className || ''}
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M0.998047 1.5C0.998047 0.947715 1.44576 0.5 1.99805 0.5H16.0015C16.5538 0.5 17.0015 0.947715 17.0015 1.5C17.0015 2.05228 16.5538 2.5 16.0015 2.5H1.99805C1.44576 2.5 0.998047 2.05228 0.998047 1.5ZM0.998047 5.5C0.998047 4.94772 1.44576 4.5 1.99805 4.5H16.0015C16.5538 4.5 17.0015 4.94772 17.0015 5.5C17.0015 6.05228 16.5538 6.5 16.0015 6.5H1.99805C1.44576 6.5 0.998047 6.05228 0.998047 5.5ZM1.99805 8.5C1.44576 8.5 0.998047 8.94771 0.998047 9.5C0.998047 10.0523 1.44576 10.5 1.99805 10.5H16.0015C16.5538 10.5 17.0015 10.0523 17.0015 9.5C17.0015 8.94771 16.5538 8.5 16.0015 8.5H1.99805Z" fill="#131E29"/>
    </svg>
  )
}

export default HamburgerMenuIcon;
